import type { DifficultyLevel } from "@akina/domain";
import { Tag } from "@akina/presentation";

const difficultyLevelToTagVariant = (difficultyLevel: DifficultyLevel | null) => {
  switch (difficultyLevel) {
    case "easy":
      return "success";
    case "medium":
      return "warning";
    case "hard":
      return "error";
    default:
      return "secondary";
  }
};

export function DifficultyTag(props: Readonly<{
  difficulty: DifficultyLevel | null;
  message: string;
}>) {
  const { difficulty, message } = props;

  return (
    <Tag variant={difficultyLevelToTagVariant(difficulty)} className="font-area text-xs font-medium">
      {message}
    </Tag>
  );
}
